import Http from '@/utils/http/index';

export default {
  /**
   * 结算明细查询
   */
  getSettlementDetailList(params) {
    return Http.get('/merchant/settlement/settlementInfoDetailList', { params });
  },
  /**
   * 结算明细下载
   */
  downloadSettlementDetail(params) {
    return Http.get('/merchant/settlement/settlementInfoDetailDownload', { params });
  },
  /**
   * 获取计费详情
   */
  getFeeDetail(params) {
    return Http.get('/merchant/settlement/getFeeDetail', { params });
  },
};
